class CartDrawerRemove extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-notification').updateQuantity(this.dataset.index, 0,undefined, this.getAttribute('data-addon')); 
       // remove custom offers
      window.CUSTOM_OFFERS.updateBoGoOffer(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-drawer-remove-button', CartDrawerRemove)

class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notificationWrapper = document.getElementById('cart-notification-wrapper');
    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.onCaptureClick = this.handleCaptureClick.bind(this);
    this.cartBubble = document.getElementById('cart-icon-bubble');
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('.cart-notification__close').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    this.cartBubble.addEventListener('click', function(e){
      e.preventDefault();
      setTimeout(function(){
        document.querySelector('cart-notification').open();
      }, 100);    
    });

    this.debouncedOnChange = debounce((event) => {
      //Prevent onchange event when message values are updated
      if(event.target.name.indexOf('attributes') >=0) { return; }

      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));

    this.querySelector('.cart-notification__message .button').addEventListener('click', function(){
      this.closest('details').removeAttribute('open');
    });
  }

  onChange(event) { 
    let giftItemkey = null, giftItemId = null;
    let dataAddOnIds = event.target.dataset.index;
    let element = document.getElementById('cart-notification-product-' + dataAddOnIds);
      if(element && element.dataset){
        if(element.dataset.addon) giftItemkey = element.dataset.addon;
      }
    if(event.target.name.indexOf('gift-wrap') >= 0){
      if (event.target.checked) {
        this.addProductFromSideCart(event.target.dataset.giftId, event.target.dataset.quantity, event.target.dataset.itemKey, true);
      }else {
        let dataAddOnId = event.target.dataset.content;
        let el = document.getElementById('cart-notification-product-' + dataAddOnId);
        document.querySelector('.floating-icons .gokwik-checkout button .btn-text').textContent = document.querySelector('#cart-notification-links .gokwik-checkout .btn-text').textContent;
        this.updateQuantity(el.getAttribute('id').replace('cart-notification-product-', ''), 0, document.activeElement.getAttribute('name'),dataAddOnId);
      }
    } else {
      this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'),giftItemkey);   
      // update custom offers
      window.CUSTOM_OFFERS.updateBoGoOffer(event.target.dataset.index, event.target.value);
    }    
  }

  open() {
    // Add animate class first (sets up transition)
    this.notification.classList.add('animate');
    this.notificationWrapper.classList.add('active');
    document.querySelector('html').classList.add('cart--open');
    document.body.classList.add('cart--open');

    // Force a reflow to ensure the element is rendered at starting position
    // before applying the active class that triggers the animation
    this.notification.offsetHeight; // Force reflow
    
    // Use requestAnimationFrame to ensure the browser has time to render
    // the initial state before starting the animation
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.notification.classList.add('active');
      });
    });

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
    document.body.addEventListener('click', this.onCaptureClick, true);
  }

  handleCaptureClick(evt) {
    const path = evt.composedPath ? evt.composedPath() : [evt.target];
    const featuredSection = document.getElementById('cart-drawer-featured-section');
    const hitFeaturedOrWishlist = path.some(function(node) {
      if (!node || node.nodeType !== 1) return false;
      if (node === featuredSection || (node.id && node.id === 'cart-drawer-featured-section')) return true;
      if (node.getAttribute && node.getAttribute('data-keep-cart-open-on-click')) return true;
      if (featuredSection && featuredSection.contains(node)) return true;
      if (node.classList && (node.classList.contains('wishlist-engine') || node.classList.contains('product-card__wishlist') || node.classList.contains('wishlist-engine-button'))) return true;
      if (node.closest) {
        var w = node.closest('.wishlist-engine, .product-card__wishlist, .wishlist-engine-button, [data-keep-cart-open-on-click]');
        if (w) return true;
      }
      return false;
    });
    if (hitFeaturedOrWishlist) {
      this._ignoreNextBodyClick = true;
    }
  }

  close() {
    this.notification.classList.remove('active');
    this.notificationWrapper.classList.remove('active');
    document.querySelector('html').classList.remove('cart--open');
    document.body.classList.remove('cart--open');

    document.body.removeEventListener('click', this.onBodyClick);
    document.body.removeEventListener('click', this.onCaptureClick, true);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    
     // Use item_count from add/update response when present (avoids extra /cart.js)
     if (typeof parsedState.item_count === 'number') {
      this.classList.toggle('is-empty', parsedState.item_count === 0);
      this.updateCartCount(parsedState.item_count);
    } else {
      // Add response does not include item_count; fetch once to update header count (same safe pattern as refreshCartDrawer)
      const cartUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root + 'cart.js' : '/cart.js';
      fetch(cartUrl)
        .then(function(r) {
          if (r.status === 429 || !r.ok) return null;
          return r.json();
        })
        .then(function(cart) {
          if (cart && typeof cart.item_count === 'number') {
            this.classList.toggle('is-empty', cart.item_count === 0);
            this.updateCartCount(cart.item_count);
          }
        }.bind(this))
        .catch(function() { /* ignore so drawer still opens */ });
    }
    
    let sectionsUpdated = false;
    
    // Check if sections data is available
    if (parsedState.sections && Object.keys(parsedState.sections).length > 0) {
      this.getSectionsToRender().forEach((section => {
        const sectionHtml = parsedState.sections[section.id];
        const element = document.getElementById(section.id);
        
        // Only update if both section HTML and element exist
        if (sectionHtml && element) {
          element.innerHTML = this.getSectionInnerHTML(sectionHtml, section.selector);
          sectionsUpdated = true;
        }
      }));
      
    }
    
    // If no sections were updated from response, fetch fresh sections
    if (!sectionsUpdated) {
      this.refreshCartDrawer();
    }
    
    this.afterCartCreatedOperations();

    if (this.header) this.header.reveal();
    this.open();
  }
  
  /**
   * Sync cart state (count, empty status).
   * No-op: cart count/is-empty rely on section rendering from /cart/add.js and /cart/update.js to avoid redundant /cart.js polling and rate limiting.
   */
  syncCartState() {
    // Intentionally empty — sections from add/update responses drive the UI
  }
  
  /**
   * Refresh cart drawer by fetching cart data and optionally sections
   * Falls back gracefully if section rendering fails (e.g., 401 in dev mode)
   */
  refreshCartDrawer() {
    // First, fetch cart data which always works
    fetch(window.Shopify.routes.root + 'cart.js')
    .then(r => {
      if (r.status === 429) {
        console.warn('Cart request rate-limited (429). Skipping refresh.');
        return null;
      }
      if (!r.ok) throw new Error('Cart unavailable');
      return r.json();
    })
    .then(cart => {
      if (!cart) return;
        // Update is-empty class based on cart item count
        this.classList.toggle('is-empty', cart.item_count === 0);
        
        // Update cart count
        this.updateCartCount(cart.item_count);
        
        // Try to fetch sections, but don't fail if it doesn't work
        // Note: Don't include cart-icon-bubble in section fetch as it can cause 400 errors in dev mode
        // The cart count is already updated via updateCartCount() above
        const sectionsToFetch = this.getSectionsToRender().map(s => s.id);
        const sectionsUrl = window.Shopify.routes.root + '?sections=' + sectionsToFetch.join(',');
        
          fetch(sectionsUrl)
          .then(r => {
            if (!r.ok) {
              console.log('Section rendering unavailable (status: ' + r.status + '), using cart data directly');
              return {};
            }
            try {
              return r.json();
            } catch (e) {
              console.log('Section response was not JSON:', e.message);
              return {};
            }
          })
          .then(sections => {
            if (sections && Object.keys(sections).length > 0) {
              this.getSectionsToRender().forEach((section => {
                const sectionHtml = sections[section.id];
                const element = document.getElementById(section.id);
                
                if (sectionHtml && element) {
                  element.innerHTML = this.getSectionInnerHTML(sectionHtml, section.selector);
                }
              }));
            }
          })
          .catch(e => {
            console.log('Section rendering failed:', e.message);
          })
          .finally(() => {
            this.afterCartCreatedOperations();
          });
      })
      .catch(error => {
        console.error('Error refreshing cart drawer:', error);
      });
  }
  
  /**
   * Update cart count in header
   */
  updateCartCount(count) {
    const cartCountBubbles = document.querySelectorAll('.cart-count-bubble');
    cartCountBubbles.forEach(bubble => {
      const countSpan = bubble.querySelector('span[aria-hidden="true"]');
      if (countSpan) {
        countSpan.textContent = count;
      }
      // Show/hide bubble based on count
      if (count > 0) {
        bubble.classList.remove('hidden');
        bubble.style.display = '';
      } else {
        bubble.classList.add('hidden');
      }
    });
  }

  getSectionsToRender() {
    // Core cart drawer sections - these must exist as section files in sections/ folder
    // Note: Only include sections that exist and work reliably
    return [
      { id: 'cart-notification-product' },
      { id: 'cart-notification-heading' },
      { id: 'cart-notification-links' },
      { id: 'cart-price-details-section' },
      { id: 'cart-free-shipping-bar' }
    ];
  }
  
  // Get additional sections that may fail in dev mode
  getOptionalSections() {
    return [
      { id: 'cart-drawer-featured-section' }
    ];
  }
  
  // Get all sections including header icon (for full page reload)
  getAllSections() {
    return [
      ...this.getSectionsToRender(),
      { id: 'cart-icon-bubble' },
      { id: 'cart-notification-messages' }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (!html) return '';
    
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const element = doc.querySelector(selector);
    
    return element ? element.innerHTML : html;
  }

  updateQuantity(line, quantity, name,dataAddon) {
    document.getElementById('cart-notification').classList.add('cart-loading');
    let formData = {updates: {}};
    formData.updates[line] = quantity;
    if (dataAddon && dataAddon.length){ 
      formData.updates[dataAddon] = quantity;
    }
    // Include all sections for rendering
    // Note: Don't include cart-icon-bubble as it can cause issues in dev mode
    const allSections = this.getSectionsToRender().map(s => s.id);
    formData.sections = allSections;
    formData.sections_url = window.location.pathname;
    
    // Use getElementById instead of querySelector to avoid CSS selector issues with special characters (like ':')
    let thisItem = document.getElementById('cart-notification-product-' + line);
    if(thisItem && thisItem.dataset && thisItem.dataset.itemTs) {
      document.querySelectorAll('.cart-item[data-item-ts="'+ thisItem.dataset.itemTs +'"]').forEach(function(el, index){
        formData.updates[el.getAttribute('id').replace('cart-notification-product-', '')] = quantity;
      });
    }
    
    // Use CSS.escape to handle special characters in attribute selectors
    const escapedLine = CSS.escape(line);
    document.querySelectorAll('.cart-item[data-item-key*="'+ escapedLine +'"]').forEach(function(el, index){
      formData.updates[el.getAttribute('id').replace('cart-notification-product-', '')] = quantity;
      formData.updates[el.getAttribute('data-item-key').replace('gift-box-', '')] = quantity;
    });
    
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(response.status === 429 ? 'Too many requests' : 'Request failed');
        }
        return response.json();
      })
      .then((parsedState) => {
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        
        // Update cart count in header
        this.updateCartCount(parsedState.item_count);
        
        // Only update sections if sections data is available
        if (parsedState.sections) {
          this.getSectionsToRender().forEach((section => {
            const sectionHtml = parsedState.sections[section.id];
            const element = document.getElementById(section.id);
            
            if (sectionHtml && element) {
              const elementToReplace = element.querySelector(section.selector) || element;
              elementToReplace.innerHTML = this.getSectionInnerHTML(sectionHtml, section.selector);
            }
          }));
        } else {
          // Fallback: refresh cart drawer manually
          this.refreshCartDrawer();
        }

        document.querySelectorAll('#cart-notification-product .cart-item').forEach(function(el, index){
          let key = el.getAttribute('data-item-key');
          let product = document.getElementById(key);
          if(product){
            product.checked = true;
          }
        });

        this.afterCartCreatedOperations();

        if(parsedState.item_count === 0) {
          const floatingGokwik = document.querySelector('.floating-icons .gokwik-checkout');
          if (floatingGokwik) floatingGokwik.classList.add('hidden');
          
          const floatingCheckoutBtn = document.querySelector('.floating__checkout-btn');
          if (floatingCheckoutBtn) floatingCheckoutBtn.classList.add('hidden');
        } else {
          const floatingGokwikBtnText = document.querySelector('.floating-icons .gokwik-checkout button .btn-text');
          const cartGokwikBtnText = document.querySelector('#cart-notification-links .gokwik-checkout .btn-text');
          if (floatingGokwikBtnText && cartGokwikBtnText) {
            floatingGokwikBtnText.textContent = cartGokwikBtnText.textContent;
          }
          
          const checkoutBtn = document.querySelector('.floating__checkout-btn');
          if (checkoutBtn) {
            checkoutBtn.classList.remove('hidden');
            const cartCheckoutBtn = document.querySelector('#cart-notification-links button[name="checkout"]');
            if (cartCheckoutBtn && cartCheckoutBtn.disabled) {
              checkoutBtn.classList.add('disabled');
            } else {
              checkoutBtn.classList.remove('disabled');
            }
          }
        }
        document.getElementById('cart-notification').classList.remove('cart-loading');
      }).catch((error) => {
        console.error('Error updating cart:', error);
        document.getElementById('cart-notification').classList.remove('cart-loading');
        
        const cartGokwikBtn = document.querySelector('#cart-notification-links .gokwik-checkout button');
        const floatingGokwikBtn = document.querySelector('.floating-icons .gokwik-checkout button');
        if (cartGokwikBtn && floatingGokwikBtn) {
          if(cartGokwikBtn.hasAttribute('disabled')){
            floatingGokwikBtn.setAttribute('disabled','disabled');
          } else {
            floatingGokwikBtn.removeAttribute('disabled');
          }
        }
      });
  }

  addProductFromSideCart(variant_id, quantity, item_id, gift) {
    document.getElementById('cart-notification').classList.add('cart-loading');
    
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    const formData = new FormData();
    formData.append('id[]', variant_id);
    formData.append('quantity', quantity);
    formData.append('properties[_gift_wrap_item_id]', item_id);
    formData.append('sections', this.getSectionsToRender().map((section) => section.id));
    formData.append('sections_url', window.location.pathname);
    
    config.body = formData;
    fetch(`${routes.cart_add_url}`, config)
    .then((response) => {
      if (response.status === 429) {
        throw new Error('Too many requests. Please wait a moment and try again.');
      }
      if (!response.ok) throw new Error('Request failed. Please try again.');
      return response.json();
    })
    .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          return;
        }

        this.renderContents(response);
        this.classList.remove('is-empty');
        
        document.querySelectorAll('#cart-notification-product .cart-item').forEach(function(el, index){
          let key = el.getAttribute('data-item-key');
          let product = document.getElementById(key);
          if(product){
            product.checked = true;
          }
        });
        
        document.getElementById('cart-notification').classList.remove('cart-loading');
        
        const floatingGokwikBtn = document.querySelector('.floating-icons .gokwik-checkout button .btn-text');
        const cartGokwikBtn = document.querySelector('#cart-notification-links .gokwik-checkout .btn-text');
        if (floatingGokwikBtn && cartGokwikBtn) {
          floatingGokwikBtn.textContent = cartGokwikBtn.textContent;
        }
      })
      .catch((e) => {
        document.getElementById('cart-notification').classList.remove('cart-loading');
      })
      .finally(() => {
        document.getElementById('cart-notification').classList.remove('cart-loading');
        // submitButton.classList.remove('loading');
        // submitButton.removeAttribute('aria-disabled');
        // this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      });
  }

  afterCartCreatedOperations() {
    let allCustomBoxDetailsElements = document.querySelectorAll('custom-box-details');

    allCustomBoxDetailsElements.forEach((el, i) => {
      // Clear existing content first to avoid duplicates
      if (el.innerHTML.includes('<p>') || el.innerHTML.includes('<span>')) return;
      
      try {
        let data = JSON.parse(el.dataset.details);
        let title = '';
        data.forEach(element => {
          if(title != element.title) {
            let p = document.createElement('p');      
            p.innerHTML = `${element.title}`;      
            el.append(p);
            title = element.title;
          }      
          let span = document.createElement('span');
          span.innerHTML = `${element.name} <span>${element.price} x ${element.qty}</span>`;
          el.append(span);
        });
      } catch (e) {
        // Ignore parsing errors
      }
    });

    let allCustomBoxMessage = document.querySelectorAll('custom-box-message');
    allCustomBoxMessage.forEach((el, i) => {
      try {
        let data = JSON.parse(el.dataset.message);
        if(data["To"] !== "" || data["From"] !== "" || data["Message"] !== "") {
          el.classList.remove('hidden');
          el.querySelector('.message').innerHTML = data["Message"];
          el.querySelector('.to').innerHTML = data["To"];
          el.querySelector('.from').innerHTML = data["From"];
        }
      } catch (e) {
        // Ignore parsing errors
      }
    });

    // Re-initialize featured collection swiper after cart update
    if (typeof window.initCartDrawerFeaturedCollection === 'function') {
      setTimeout(window.initCartDrawerFeaturedCollection, 200);
    }
    // No /cart.js fetch here — cart relies on section rendering from /cart/add.js and /cart/update.js to reduce rate limiting
  }

  handleBodyClick(evt) {
    if (this._ignoreNextBodyClick) {
      this._ignoreNextBodyClick = false;
      return;
    }
    const target = evt.target;
    const path = evt.composedPath ? evt.composedPath() : [target];
    const isInsideCart = path.some(function(node) {
      if (!node || node.nodeType !== 1) return false;
      if (node === this) return true;
      if (this.contains(node)) return true;
      if (node.id === 'cart-drawer-featured-section') return true;
      if (node.classList && (node.classList.contains('wishlist-engine') || node.classList.contains('product-card__wishlist') || node.classList.contains('wishlist-engine-button'))) return true;
      if (node.closest && (node.closest('.wishlist-engine') || node.closest('#cart-drawer-featured-section'))) return true;
      return false;
    }.bind(this));
    if (!isInsideCart) {
      const disclosure = target.closest ? target.closest('details-disclosure') : null;
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  /**
   * Global add to cart method that can be called from anywhere
   * @param {Object} options - Add to cart options
   * @param {number|string} options.id - Variant ID to add
   * @param {number} options.quantity - Quantity to add (default: 1)
   * @param {Object} options.properties - Line item properties (optional)
   * @param {Array} options.items - Array of items to add (alternative to single id/quantity)
   * @returns {Promise} - Promise that resolves with the cart response
   */
  addToCart(options = {}) {
    return new Promise((resolve, reject) => {
      document.getElementById('cart-notification').classList.add('cart-loading');
      
      // Build the request body
      let requestBody = {};
      
      if (options.items && Array.isArray(options.items)) {
        // Multiple items
        requestBody.items = options.items;
      } else if (options.id) {
        // Single item
        requestBody.items = [{
          id: parseInt(options.id),
          quantity: options.quantity || 1,
          properties: options.properties || {}
        }];
      } else {
        document.getElementById('cart-notification').classList.remove('cart-loading');
        reject(new Error('No variant ID or items provided'));
        return;
      }
      
      // Add sections for rendering
      // Note: Don't include cart-icon-bubble as it can cause issues in dev mode
      const allSections = this.getSectionsToRender().map(s => s.id);
      requestBody.sections = allSections;
      requestBody.sections_url = window.location.pathname;
      
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(requestBody)
      })
      .then((response) => {
        if (response.status === 429) {
          throw new Error('Too many requests. Please wait a moment and try again.');
        }
        if (!response.ok) throw new Error('Request failed. Please try again.');
        return response.json();
      })
      .then((response) => {
        if (response.status) {
          // Error response from Shopify
          document.getElementById('cart-notification').classList.remove('cart-loading');
          reject(new Error(response.description || 'Failed to add to cart'));
          return;
        }
        
        // Success - render contents and open drawer
        this.renderContents(response);
        this.classList.remove('is-empty');
        
        // Update floating checkout button
        const floatingCheckout = document.querySelector('.floating-icons .gokwik-checkout');
        if (floatingCheckout) {
          floatingCheckout.classList.remove('hidden');
          const btnText = document.querySelector('#cart-notification-links .gokwik-checkout .btn-text');
          const floatingBtnText = floatingCheckout.querySelector('.btn-text');
          if (btnText && floatingBtnText) {
            floatingBtnText.textContent = btnText.textContent;
          }
        }
        
        // Show floating checkout button
        const checkoutBtn = document.querySelector('.floating__checkout-btn');
        if (checkoutBtn) {
          checkoutBtn.classList.remove('hidden');
        }
        
        // Run custom offers if available
        if (window.CUSTOM_OFFERS && typeof window.CUSTOM_OFFERS.runCustomOffers === 'function') {
          window.CUSTOM_OFFERS.runCustomOffers();
        }
        
        document.getElementById('cart-notification').classList.remove('cart-loading');
        resolve(response);
      })
      .catch((error) => {
        document.getElementById('cart-notification').classList.remove('cart-loading');
        reject(error);
      });
    });
  }
}

customElements.define('cart-notification', CartNotification);

/**
 * Global helper function to add to cart and open drawer
 * Can be called from anywhere: window.addToCartAndOpenDrawer({ id: variantId, quantity: 1 })
 */
window.addToCartAndOpenDrawer = function(options) {
  const cartNotification = document.querySelector('cart-notification');
  if (cartNotification && typeof cartNotification.addToCart === 'function') {
    return cartNotification.addToCart(options);
  } else {
    console.error('Cart notification not found');
    return Promise.reject(new Error('Cart notification not found'));
  }
};

/**
 * Cart Drawer Add to Cart Function
 * Used by buttons in the cart drawer featured collection
 * Defined here to ensure it's available early, before any potential syntax errors on the page
 */
window.cartDrawerAddToCart = async function(btn) {
  if (!btn || btn.disabled) return;
  
  var variantId = btn.getAttribute('data-variant-id');
  if (!variantId) {
    alert('Unable to add product - missing variant ID');
    return;
  }
  
  btn.disabled = true;
  var originalText = btn.textContent;
  btn.textContent = 'ADDING...';
  
  try {
    var response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId), quantity: 1 }],
        sections: ['cart-notification-product', 'cart-notification-heading', 'cart-notification-links', 'cart-price-details-section', 'cart-free-shipping-bar'],
        sections_url: window.location.pathname
      })
    });
    
    if (response.status === 429) {
      throw new Error('Too many requests. Please wait a moment and try again.');
    }
    if (!response.ok) {
      throw new Error('Request failed. Please try again.');
    }
    var data = await response.json();
    
    if (data.status) {
      alert(data.description || 'Failed to add product to cart.');
      btn.textContent = originalText;
      btn.disabled = false;
      return;
    }
    
    btn.textContent = 'ADDED!';
    
    // Update cart drawer
    var cartNotification = document.querySelector('cart-notification');
    if (cartNotification) {
      cartNotification.classList.remove('is-empty');
      if (typeof cartNotification.renderContents === 'function') {
        cartNotification.renderContents(data);
      } else if (typeof cartNotification.refreshCartDrawer === 'function') {
        cartNotification.refreshCartDrawer();
      }
      
      // Only open the cart drawer if it's not already open
      // Check if drawer is already active to avoid overlay flash
      var isAlreadyOpen = cartNotification.classList.contains('active');
      if (!isAlreadyOpen) {
        // Use the proper open method if available
        if (typeof cartNotification.open === 'function') {
          cartNotification.open();
        } else {
          // Fallback: add classes manually
          var notificationWrapper = document.getElementById('cart-notification-wrapper');
          var notification = document.getElementById('cart-notification');
          if (notificationWrapper) notificationWrapper.classList.add('active');
          if (notification) notification.classList.add('animate', 'active');
          cartNotification.setAttribute('aria-hidden', 'false');
          document.body.classList.add('overflow-hidden');
        }
      }
    }
    
    // Update cart count
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(function(res) {
        if (!res.ok) return null;
        return res.json();
      })
      .then(function(cart) {
        if (!cart) return;
        var bubbles = document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]');
        bubbles.forEach(function(b) { b.textContent = cart.item_count; });
      });
    
    // Update floating buttons
    var floatingCheckout = document.querySelector('.floating-icons .gokwik-checkout');
    if (floatingCheckout) floatingCheckout.classList.remove('hidden');
    var checkoutBtn = document.querySelector('.floating__checkout-btn');
    if (checkoutBtn) checkoutBtn.classList.remove('hidden');
    
    // Run custom offers
    if (window.CUSTOM_OFFERS && typeof window.CUSTOM_OFFERS.runCustomOffers === 'function') {
      window.CUSTOM_OFFERS.runCustomOffers();
    }
    
    setTimeout(function() {
      btn.textContent = originalText;
      btn.disabled = false;
    }, 2000);
    
  } catch (error) {
    console.error('Add to cart error:', error);
    alert('Failed to add product to cart. Please try again.');
    btn.textContent = originalText;
    btn.disabled = false;
  }
};

/**
 * Global event listener for cart:add custom event
 * Allows triggering add to cart from anywhere via: 
 * document.dispatchEvent(new CustomEvent('cart:add', { detail: { id: variantId, quantity: 1 } }))
 */
document.addEventListener('cart:add', function(event) {
  if (event.detail) {
    window.addToCartAndOpenDrawer(event.detail);
  }
});

/**
 * React to product-form.js add-to-cart: update drawer and open it.
 * product-form.js is the single source of truth; it dispatches cart:updated with the /cart/add.js response.
 */
document.addEventListener('cart:updated', function(event) {
  const cartNotification = document.querySelector('cart-notification');
  if (!cartNotification || !event.detail || !event.detail.cart) return;
  cartNotification.renderContents(event.detail.cart);
  cartNotification.classList.remove('is-empty');
  cartNotification.open();
});

/**
 * Global form interceptor for add-to-cart forms
 * Catches any form submissions to /cart/add that aren't handled by custom elements
 * and ensures the cart drawer opens properly
 */
(function() {
  'use strict';
  
  document.addEventListener('submit', function(event) {
    const form = event.target;
    
    // Only intercept forms that add to cart
    if (!form || !form.action || !form.action.includes('/cart/add')) return;
    
    // Skip if form is inside a product-form custom element (already handled)
    if (form.closest('product-form')) return;
    
    // Skip if form has data-no-drawer attribute (opt-out mechanism)
    if (form.hasAttribute('data-no-drawer')) return;
    
    // Skip if form is inside cart drawer featured collection (already handled)
    if (form.closest('.featured-collection-advanced-cart-drawer-featured')) return;
    if (form.closest('#cart-drawer-featured-section')) return;
    
    event.preventDefault();
    
    const submitButton = form.querySelector('[type="submit"]');
    const variantInput = form.querySelector('input[name="id"], input[name="id[]"]');
    const quantityInput = form.querySelector('input[name="quantity"]');
    
    if (!variantInput) return;
    
    const variantId = variantInput.value;
    const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
    
    // Show loading state
    const originalText = submitButton ? submitButton.textContent : '';
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = 'Adding...';
      const spinner = submitButton.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');
    }
    
    // Use global add to cart function
    if (typeof window.addToCartAndOpenDrawer === 'function') {
      window.addToCartAndOpenDrawer({ id: variantId, quantity: quantity })
        .then(() => {
          // Reset button state
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.textContent = originalText;
            const spinner = submitButton.querySelector('.loading-overlay__spinner');
            if (spinner) spinner.classList.add('hidden');
          }
        })
        .catch((error) => {
          console.error('Add to cart error:', error);
          alert(error.message || 'Failed to add product to cart');
          // Reset button state
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.textContent = originalText;
            const spinner = submitButton.querySelector('.loading-overlay__spinner');
            if (spinner) spinner.classList.add('hidden');
          }
        });
    } else {
      // Fallback: submit form normally if global function not available
      form.submit();
    }
  }, true); // Use capture phase to intercept before other handlers
})();
